/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Export a saved search's aggregated Insights report (no profiles).
 */
export interface SearchInsightsExportSourceSchema {
  type?: 'search_insights';
  search_id: string;
}
